export default "__VITE_ASSET__f4b6ef34__"